module.exports = __webpack_public_path__ + "static/media/twitter.d4609d7d.png";